<template>
  <div class="label">
    <p :style="{ color: labelColor }" v-html="value" />
  </div>
</template>

<script>
export default {
  name: "SectionLabel",
  props: {
    value: String,
    labelColor: {
      type: String,
      default: "#121212"
    }
  }
};
</script>

<style scoped>
p {
  margin-bottom: 16px;
  margin-top: 0px;
  font-family: BentonSansBBVA-Medium;
  font-size: 15px;
  color: #121212;
}
</style>
